module.exports = __webpack_public_path__ + "img/brand-11.45693ce4.png";